import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { Observable } from "rxjs";
import { IRound } from "../interfaces";
import { RoundRepository } from "../round.repository";
import { map } from "rxjs/operators";
import { IUserBet } from "../store/interfaces";

@Injectable()
export class GetUserBetByIndexUseCase implements IUseCase<number, Observable<IUserBet | undefined>> {
    constructor(private roundRepository: RoundRepository) {
    }

    execute(betIndex: number): Observable<IUserBet | undefined> {
        return this.roundRepository.get().pipe(map((round: IRound) => round.userBets.find(b => b.betIndex === betIndex)));
    }
}
